import React from 'react';
import { Container } from 'react-bootstrap';
import Button from '../../../components/Button';
import CriticalIllnessModal from './criticalIllnessModal';

const CriticalIllnessModalDemo = () => {
  const [showCriticalIllnessModal, setShowCriticalIllnessModal] =
    React.useState<boolean>(false);

  const handleShowBaseLifeInsuranceModal = () =>
    setShowCriticalIllnessModal(true);
  const handleCloseCriticalIllnessModal = () =>
    setShowCriticalIllnessModal(false);

  return (
    <Container>
      <Container className="mt-10">
        <h4>Critical Illness Modal</h4>
        <Button onMouseDown={handleShowBaseLifeInsuranceModal}>
          Open Modal
        </Button>
        <CriticalIllnessModal
          showCriticalIllnessModal={showCriticalIllnessModal}
          handleCloseCriticalIllnessModal={handleCloseCriticalIllnessModal}
        />
      </Container>
    </Container>
  );
};

export default CriticalIllnessModalDemo;
